module.exports = __webpack_public_path__ + "media/socup.93417988.mp4";